// Experience Page
export const experience = {
  title: "Experience",
  subtitle: "Work, Internship and Volunteership",
  description:
    "My professional work experience",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      work: true,
      experiences: [
        {
          title: "Software-Architect, Mobile Developer",
          company: "jambit GmbH",
          company_url: "https://www.jambit.com",
          logo_path: "jambit.svg",
          duration: "Jan 2018 - Present",
          location: "Munich, Germany",
          description: 
            "As a seasoned Mobile Software Architect and Developer, I specialize in designing and implementing innovative solutions for both iOS and Android platforms.\n\n" +
            "My experience at jambit, a distinguished Software-Service-Provider, has allowed me to work across various industries, including automotive, media, banking, and insurance.\n\n" +
            "This diverse background has provided me with a deep understanding of different technical requirements and client needs.\n\n" +
            "I have navigated both small-scale projects and large-scale environments, including scaled agile frameworks with up to three hundred people. This wide-ranging experience enables me to effectively adapt to various project sizes and complexities, ensuring successful outcomes and seamless integration within any organizational setting.",
        },
        {
          title: "Working Student, iOS Developer",
          company: "jambit GmbH",
          company_url: "https://www.jambit.com",
          logo_path: "jambit.svg",
          duration: "Jan 2016 - Jan 2018",
          location: "Munich, Gernany",
          description:
            "During my time as a Working Student, I was involved in various teams dedicated to developing iOS applications for our clients.\n\n" +
            "This role allowed me to gain professional iOS developer skills while working alongside a team of highly skilled developers. I contributed to the development process, learning best practices and advanced techniques in iOS development.",
          color: "#0879bf",
        },
      ],
    },
    {
      title: "Internships",
      experiences: [
        {
          title: "Internship",
          company: "TRUMPF SE + Co. KG",
          company_url: "https://www.trumpf.com/de_DE/",
          logo_path: "trumpf.svg",
          duration: "October 2014 - March 2015",
          location: "Pune, Maharashtra",
          description:
            "During my internship at Trumpf Laser Company, the world leader in laser technology, I contributed to the development of cutting-edge laser glass cutting techniques.\n\n" +
            "I worked on pioneering methods that enhance the precision, speed, and efficiency of glass cutting processes. My involvement helped advance state-of-the-art technology, aiming to set new industry standards and improve overall performance in glass cutting applications.",
          color: "#9b1578",
        },
      ],
    },
    {
      title: "Volunteerships",
      experiences: [
        {
          title: "Tutoring for socially disadvantaged children",
          company: "Tintenklecks e.v. Constance",
          company_url: "https://www.uni-konstanz.de/hsg/tintenklecks/",
          logo_path: "tintenklecks.png",
          duration: "2013 - 2014",
          location: "Hyderabad, Telangana",
          description:
            "As a volunteer tutor with Tintenklecks e.V., I supported an organization dedicated to connecting socially disadvantaged children with volunteer students who provide free tutoring.\n\n" +
            "My role involved helping children with their school subjects, offering educational support to those who could not afford paid tutoring. This experience allowed me to contribute to the community and make a positive impact on the educational opportunities available to these children.",
          color: "#4285F4",
        },
        
      ],
    },
  ],
};